import React from 'react';
import './styles/UI.css';

const ErrorMessage = ({ message, onClose }) => {
  return (
    <div className="error-message">
      {message}
      <button 
        className="error-close-btn"
        onClick={onClose}
      >
        ×
      </button>
    </div>
  );
};

export default ErrorMessage; 